module.exports = __webpack_public_path__ + "img/icon-expert.088bda71.png";